// import { allowedRoutes } from "./routes";

export const aboutUs = [
  {
    title: "Order with Cuisine Compass",
    desc: "Fast delivery with fresh cooked cuisines from your nearby restaurants.",
    buttonTitle: "Order Now",
    link: "/cuisine/compass/restaurants",
  },
  {
    title: "Become a Partner",
    desc: "Grow your business and reach new customers by partnering with us.",
    buttonTitle: "Sign Up Your Store",
    link: "/cuisine/compass/mybusiness/signup/Business",
  },
  {
    title: "Customer Loyality",
    desc: "Know who your best customers are so you can reward them and keep them coming back.",
    buttonTitle: "Loyality",
    link: "/cuisine/compass/loyality",
  },
];
